import {useNuxtApp} from 'nuxt/app'
import {useUserStore} from '@/store/user'
import {useAuthStore} from '@/store/auth'
import type {UserManager} from 'oidc-client-ts'
import {clearImpersonationToken} from './useKeycloakToken'

export function getKeycloakHomePath() {
  const app = useNuxtApp()
  const locale = app.$i18n.locale.value ?? 'en'
  const region = app.$globalization.getRegion(false) ?? 'eu'
  return app.$globalization.localePath('index', locale, region)
}

export function resolveRedirectPath(redirectPath?: string) {
  if (!redirectPath) {
    return '/eu/en'
  }

  const match = /customerUuid=([^&]+)/.exec(redirectPath)
  if (match?.[1]) {
    const userStore = useUserStore()
    userStore.customerUuidLink = match[1]
  }

  return redirectPath
}

export async function clearKeycloakState(userManager?: UserManager | null) {
  const authStore = useAuthStore()
  const userStore = useUserStore()

  authStore.setUserObject(null)
  userStore.accessToken = ''

  // Drop any per-tab impersonation session so a logout never leaves an impersonated token behind.
  clearImpersonationToken()

  if (userManager) {
    await userManager.removeUser()
  }

  // Remove the SSR "logged-in" marker cookie. Without this, a logout whose
  // SSO redirect is blocked (e.g. by CSP) leaves this cookie behind, and the
  // server keeps treating the user as logged in (see ssr-middleware.js).
  if (process.client) {
    const {CookieStorage} = await import('cookie-storage')
    const cookieStorage = new CookieStorage({path: '/'})
    cookieStorage.removeItem('ENuxtKeycloakUser.sub')
  }
}
